import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchTicketByToken } from '../components/api';
import TicketDetailModal from '../components/TicketDetailModal';
import { UserContext } from '../context/UserContext';

const GuestTicketPage = () => {
  const { token } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const t = await fetchTicketByToken(token);
        setTicket(t);
      } catch (err) {
        console.error('Failed to fetch ticket', err);
        setError(err.message || 'Failed to load ticket');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading…</div>;
  if (error)   return <div className="flex items-center justify-center min-h-screen text-red-600">{error}</div>;
  if (!ticket) return <div className="flex items-center justify-center min-h-screen">Ticket not found</div>;

  // Provide empty user context so TicketDetailModal doesn't crash
  const ctxValue = { user: {}, setUser: () => {} };

  return (
    <UserContext.Provider value={ctxValue}>
      <TicketDetailModal
        isOpen={true}
        onClose={() => {
          // Navigate back if possible
          window.history.length > 1 ? window.history.back() : window.close();
        }}
        ticket={ticket}
        onTicketUpdated={setTicket}
      />
    </UserContext.Provider>
  );
};

export default GuestTicketPage; 